<app-header *ngIf="env.header" class="sticky top-0 w-full z-[2]"></app-header>
<app-sidebar *ngIf="env.sidebar" [menu]="menu"></app-sidebar>
<main id="cttMain">
    <router-outlet class="contents"></router-outlet>
    <!-- <app-footer *ngIf="env.footer"></app-footer> -->
</main>